<div class="banner container-fluid">
    <div class="row">
      <div class="col-12">
        <div>WorkPASS</div>
        <div>Working Permit Application Services System</div>
      </div>
    </div>
  </div>
  